<template>
  <div class="management-contract">
    <el-card>
      <el-form>
        <el-form-item>
          <el-select
            v-model="diseaseId"
            placeholder="请选择疾病类型"
            style="width: 300px"
            @change="changeDisease"
          >
            <el-option
              v-for="item in PatientLabel"
              :key="item.id"
              :label="item.diseaseName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- <el-card class="card">
      <quill-editor ref="text" v-model="content" class="myQuillEditor" :options="editorOption" />
    </el-card> -->



    <el-card class="card">
      <p style="width:100%;height:60px;">
      <label class="labelLeft"
        >健康现状<span class="red">(字数限制500字)</span></label
      >
      <label class="labelRight"
        ><el-button type="primary" @click="chiosTemplate('comprehensive')"
          >选择模板</el-button
        ></label
      >
      </p>
      <editorVue v-model="comprehensive" :height="400" style="display:block;"></editorVue>
      <!-- <el-input
        type="textarea"
        :rows="7"
        placeholder="请输入内容"
        v-model="comprehensive"
      >
      </el-input> -->
    </el-card>
    <el-card class="card">
      <p style="width:100%;height:60px;">
      <label class="labelLeft"
        >饮食建议<span class="red">(字数限制500字)</span></label
      >
      <label class="labelRight"
        ><el-button type="primary" @click="chiosTemplate('Nutrition')"
          >选择模板</el-button
        ></label
      >
      </p>
      <editorVue v-model="Nutrition" :height="400" style="display:block;"></editorVue>
      <!-- <el-input
        type="textarea"
        :rows="7"
        placeholder="请输入内容"
        v-model="Nutrition"
      >
      </el-input> -->
    </el-card>
    <el-card class="card">
      <p style="width:100%;height:60px;">
      <label class="labelLeft"
        >运动建议<span class="red">(字数限制500字)</span></label
      >
      <label class="labelRight"
        ><el-button type="primary" @click="chiosTemplate('psychology')"
          >选择模板</el-button
        ></label
      >
      </p>
      <editorVue v-model="psychology" :height="400" style="display:block;"></editorVue>
      <!-- <el-input
        type="textarea"
        :rows="7"
        placeholder="请输入内容"
        v-model="psychology"
      >
      </el-input> -->
    </el-card>
    <el-card class="card">
      <p style="width:100%;height:60px;">
      <label class="labelLeft"
        >快乐生活<span class="red">(字数限制500字)</span></label
      >
      <label class="labelRight"
        ><el-button type="primary" @click="chiosTemplate('motion')"
          >选择模板</el-button
        ></label
      >
      </p>
      <editorVue v-model="motion" :height="400" style="display:block;"></editorVue>
      <!-- <el-input
        type="textarea"
        :rows="7"
        placeholder="请输入内容"
        v-model="motion"
      >
      </el-input> -->
    </el-card>
    <el-card class="card">
      <p style="width:100%;height:60px;">
      <label class="labelLeft"
        >病症控制<span class="red">(字数限制500字)</span></label
      >
      <label class="labelRight"
        ><el-button type="primary" @click="chiosTemplate('other')"
          >选择模板</el-button
        ></label
      >
      </p>
      <editorVue v-model="other" :height="400" style="display:block;"></editorVue>
      <!-- <el-input
        type="textarea"
        :rows="7"
        placeholder="请输入内容"
        v-model="other"
      >
      </el-input> -->
    </el-card>

    <el-card class="card">
      <p style="width:100%;height:60px;">
      <label class="labelLeft"
        >其他建议<span class="red">(字数限制500字)</span></label
      >
      <label class="labelRight"
        ><el-button type="primary" @click="chiosTemplate('programme')"
          >选择模板</el-button
        ></label
      >
      </p>
      <editorVue v-model="programme" :height="400" style="display:block;"></editorVue>
      <!-- <el-input
        type="textarea"
        :rows="7"
        placeholder="请输入内容"
        v-model="programme"
      >
      </el-input> -->
    </el-card>
    <el-card style="text-align: center">
      <el-button type="primary" @click="add">保存</el-button>
      <el-button type="danger" @click="cancel">取消</el-button>
    </el-card>
    <el-dialog
      title="选择健康建议模板"
      :visible.sync="choiceshow"
      width="70%"
      style="height: 600px"
    >
      <el-col>
        类别
        <el-select v-model="value" placeholder="请选择" @change="changeTab">
          <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.diseaseName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col style="margin-top: 20px">
        <el-tabs type="border-card" @tab-click="handleClick">
          <!-- @tab-click="handleClick" -->
          <el-tab-pane
            :label="item.tabName"
            v-for="(item, index) in tabList"
            :key="index"
          >
            <div
              v-for="(item2, index2) in item.sanboManagerTemplateVoList"
              :key="index2"
              style="margin-top: 20px"
            >
              <el-checkbox v-model="item2.checked">{{
                item2.templateName
              }}</el-checkbox>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-button
        type="primary"
        @click="determine"
        style="margin: 0 auto; display: block; margin-top: 300px"
        >确定</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import editorVue from "./editor.vue";
import { Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      content:'',
      editorOption: {},
      list: [],
      PatientLabel: [],
      tabList: [],
      textarea: "",
      choiceshow: false,
      value: "",
      tabindex: 0,
      checked: false,
      chiostemplatevariable: "",
      Nutrition: "",
      psychology: "",
      motion: "",
      other: "",
      comprehensive: "",
      programme: "",
      bloodPressureLow: "",
      bloodPressureHigh: "",
      glycosylatedHemoglobin: "",
      asthmaControlScore: "",
      id: "",
      diseaseId:''
    };
  },
  components: {
    editorVue
  },
  mounted() {
    let that = this;
    if (that.$route.query.detailsId) {
      that.id = that.$route.query.detailsId;
      that.init();
    } else {
      that.id = that.$route.query.id;
      that.inittabList();
    }
  },
  methods: {
    changeDisease(){
      let that = this;
      axiosUtil(
        {
          diseaseTypeId:that.diseaseId,
          service: "smarthos.sanbo.health.manager.tab.template.disease.type.list",
          source:'SANBOYUN'
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            if(JSON.stringify(list)!='[]'){
              for(let i in list){
                if(list[i].tabName=='健康现状'){
                  that.comprehensive=list[i].sanboManagerTemplateVo.templateContent
                }else if(list[i].tabName=='饮食建议'){
                  that.Nutrition=list[i].sanboManagerTemplateVo.templateContent
                }else if(list[i].tabName=='运动建议'){
                  that.psychology=list[i].sanboManagerTemplateVo.templateContent
                }else if(list[i].tabName=='快乐生活'){
                  that.motion=list[i].sanboManagerTemplateVo.templateContent
                }else if(list[i].tabName=='病症控制'){
                  that.other=list[i].sanboManagerTemplateVo.templateContent
                }else if(list[i].tabName=='其他建议'){
                  that.programme=list[i].sanboManagerTemplateVo.templateContent
                }
              }
            }
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    inittabList() {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.health.manager.tab.template.list",
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            that.PatientLabel = list;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    init() {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.member.health.manager.scheme.detail",
          managerSchemeId: that.id,
          docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            that.asthmaControlScore = obj.asthmaControlScore;
            that.bloodPressureHigh = obj.bloodPressureHigh;
            that.bloodPressureLow = obj.bloodPressureLow;
            that.comprehensive = obj.comprehensiveAssessments;
            that.glycosylatedHemoglobin = obj.glycosylatedHemoglobin;
            that.programme = obj.managementPlan;
            that.Nutrition = obj.nutritionalAssessment;
            that.other = obj.otherAssessments;
            that.motion = obj.sportsAssessment;
            that.psychology = obj.psychologicalAssessment;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    handleClick: function (tab, event) {
      //获取到当前元素的id
      if (event.target.getAttribute("id") == "tab-0") {
        this.tabindex = 0;
      } else if (event.target.getAttribute("id") == "tab-1") {
        this.tabindex = 1;
      }
    },
    determine() {
      let that = this;

      if (that.chiostemplatevariable == "Nutrition") {
        for (let i in that.tabList) {
          for (let j in that.tabList[i].sanboManagerTemplateVoList) {
            if (that.tabList[i].sanboManagerTemplateVoList[j].checked) {
              that.Nutrition =
                that.tabList[i].sanboManagerTemplateVoList[j].templateContent;
              break;
            }
          }
        }
      } else if (that.chiostemplatevariable == "psychology") {
        for (let i in that.tabList) {
          for (let j in that.tabList[i].sanboManagerTemplateVoList) {
            if (that.tabList[i].sanboManagerTemplateVoList[j].checked) {
              that.psychology =
                that.tabList[i].sanboManagerTemplateVoList[j].templateContent;
              break;
            }
          }
        }
      } else if (that.chiostemplatevariable == "motion") {
        for (let i in that.tabList) {
          for (let j in that.tabList[i].sanboManagerTemplateVoList) {
            if (that.tabList[i].sanboManagerTemplateVoList[j].checked) {
              that.motion =
                that.tabList[i].sanboManagerTemplateVoList[j].templateContent;
              break;
            }
          }
        }
      } else if (that.chiostemplatevariable == "other") {
        for (let i in that.tabList) {
          for (let j in that.tabList[i].sanboManagerTemplateVoList) {
            if (that.tabList[i].sanboManagerTemplateVoList[j].checked) {
              that.other =
                that.tabList[i].sanboManagerTemplateVoList[j].templateContent;
              break;
            }
          }
        }
      } else if (that.chiostemplatevariable == "comprehensive") {
        for (let i in that.tabList) {
          for (let j in that.tabList[i].sanboManagerTemplateVoList) {
            if (that.tabList[i].sanboManagerTemplateVoList[j].checked) {
              that.comprehensive =
                that.tabList[i].sanboManagerTemplateVoList[j].templateContent;
              break;
            }
          }
        }
      } else if (that.chiostemplatevariable == "programme") {
        for (let i in that.tabList) {
          for (let j in that.tabList[i].sanboManagerTemplateVoList) {
            if (that.tabList[i].sanboManagerTemplateVoList[j].checked) {
              that.programme =
                that.tabList[i].sanboManagerTemplateVoList[j].templateContent;
              break;
            }
          }
        }
      }
      that.choiceshow = false;
      that.checked = false;
    },
    add() {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.member.health.manager.scheme.save",
          docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
          memberId: that.id,
          nutritionalAssessment: that.Nutrition,
          psychologicalAssessment: that.psychology,
          sportsAssessment: that.motion,
          otherAssessments: that.other,
          comprehensiveAssessments: that.comprehensive,
          managementPlan: that.programme,
          bloodPressureLow: that.bloodPressureLow,
          bloodPressureHigh: that.bloodPressureHigh,
          glycosylatedHemoglobin: that.glycosylatedHemoglobin,
          asthmaControlScore: that.asthmaControlScore,
          pageUrl: "/pagesProgramme/list/list",
          planContent: that.programme,
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            this.$router.push({
              path: "programmeList",
              query: { id: that.id },
            });
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    changeTab() {
      let that = this;
      for (let i in that.list) {
        if (that.list[i].id == that.value) {
          that.tabList = that.list[i].sanboManagerTabTypeVoList;
        }
      }
    },
    initData() {
      let that = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.health.manager.tab.template.list",
        },
        ({ code, list, msg }) => {
          if (code == "0") {
            that.list = list;
            that.value = list[0].id;
            that.tabList = list[0].sanboManagerTabTypeVoList;
            that.choiceshow = true;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    chiosTemplate(variable) {
      this.chiostemplatevariable = variable;
      this.initData();
    },
    cancel() {
      this.$router.push({
        path: "programmeList",
        query: { id: this.$route.query.id },
      });
    },
  },
};
</script>

<style lang="scss">
.management-contract {
  width: 100%;
  height: 100%;
  background: #fff;
}
.card {
  width: 50%;
  height: 600px;
  float: left;
}
.labelLeft {
  margin-bottom: 20px;
  display: block;
  float: left;
}
.red {
  color: #ff0000;
  margin-left: 10px;
}
.labelRight {
  float: right;
  margin-bottom: 20px;
}
.doctorView {
  margin-top: 30px;
}
.doctorName {
  display: inline-block;
  float: left;
  line-height: 40px;
  margin-left: 20px;
}
.nameInput {
  display: inline-block;
  float: left;
  width: 200px;
  height: 40px;
  margin-left: 20px;
}
.pressure {
  display: inline-block;
  width: 150px;
  height: 40px;
}
.title {
  margin-left: 20px;
}
.target {
  margin-bottom: 20px;
}
.el-dialog__body {
  height: 500px;
}
</style>
